<div class="p-6 max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-1">Filtering</p>
  <p class="text-sm text-[var(--tertiary-text)] mb-4">Which filters would you like to apply?</p>

  <div class="mb-4">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>Client</mat-label>
      <mat-select [(ngModel)]="selectedClientId">
        <mat-option style="background-color: white!important; padding: 6px!important;">
          <div class="flex justify-center">
            <ngx-mat-select-search placeholderLabel="Search Clients" [formControl]="clientFilterCtrl">
              <span ngxMatSelectNoEntriesFound>No entries found</span>
            </ngx-mat-select-search>
          </div>
        </mat-option>
        <mat-option *ngFor="let customer of filterCustomerList" [value]="customer.id">
          {{customer.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex gap-3 mb-4">
    <mat-form-field class="flex-1" appearance="outline">
      <mat-label>Start Date</mat-label>
      <input [max]="endDate" matInput [(ngModel)]="startDate" [matDatepicker]="picker">
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-1" appearance="outline">
      <mat-label>End Date</mat-label>
      <input [min]="startDate" matInput [(ngModel)]="endDate" [matDatepicker]="picker2">
      <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>

  <div *ngIf="submissionTypes?.length > 0" class="mb-2">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label appRemoveAriaOwns>Select Analysis Type</mat-label>
      <mat-select [(ngModel)]="selectedSubmissionType">
        <mat-option *ngFor="let type of submissionTypes" [value]="type.id">
          {{type.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="recManTypes?.length > 0" class="mb-2">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label appRemoveAriaOwns>Select Recommendation Type</mat-label>
      <mat-select [(ngModel)]="selectedRecManTypeId">
        <mat-option *ngFor="let rec of recManTypes" [value]="rec.id">
          {{rec.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="statusList?.length > 0" class="mb-2">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label appRemoveAriaOwns>Select Status</mat-label>
      <mat-select multiple [(ngModel)]="selectedStatusIds">
        <mat-option *ngFor="let status of statusList" [value]="status.id">
          {{status.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="labAgentList?.length > 0" class="mb-2">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label appRemoveAriaOwns>Select User</mat-label>
      <mat-select [(ngModel)]="selectedLabAgentId">
        <mat-option *ngFor="let agent of labAgentList" [value]="agent.id">
          {{agent?.name + ' ' + agent?.surname}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-3 mt-4">
    <button (click)="closeDialog(true)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="closeDialog(false)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Apply</button>
  </div>
</div>
